/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { PostUsersMutationRequest, PostUsersMutationResponse, PostUsers400 } from '../entities/PostUsers'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { postUsers } from '../api/postUsers'
import { useMutation } from '@tanstack/react-query'

export const postUsersMutationKey = () => [{ url: '/users' }] as const

export type PostUsersMutationKey = ReturnType<typeof postUsersMutationKey>

/**
 * @description Создание пользователя админом компании
 * @summary Создание пользователя
 * {@link /users}
 */
export function usePostUsers<TContext>(
  options: {
    mutation?: UseMutationOptions<PostUsersMutationResponse, ResponseErrorConfig<PostUsers400>, { data: PostUsersMutationRequest }, TContext> & {
      client?: QueryClient
    }
    client?: Partial<RequestConfig<PostUsersMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? postUsersMutationKey()

  return useMutation<PostUsersMutationResponse, ResponseErrorConfig<PostUsers400>, { data: PostUsersMutationRequest }, TContext>(
    {
      mutationFn: async ({ data }) => {
        return postUsers(data, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}